import {QueryResult} from '@apollo/react-common';
import React from 'react';

import {InstrumentedLoader as Loader} from './../components/utility/InstrumentedLoader';

interface DeferredQueryDataProps {
  query: Pick<QueryResult, 'data' | 'loading'>;
  children: (data: QueryResult['data']) => JSX.Element | null;
  name?: string;
}

const DeferredQueryData = React.memo(
  ({query, children, name}: DeferredQueryDataProps) => {
    const {data, loading} = query;
    // if (query.error != null) {
    //   // TODO(axel): show proper error state
    // }

    if (loading) {
      const prefix = name ? `${name}-` : ``;

      return (
        <div style={{position: 'relative', height: 200, marginBottom: 40}}>
          <Loader name={`${prefix}deferred-query-loader`} />
        </div>
      );
    }
    return children(data);
  }
);

export default DeferredQueryData;
